import isEqual from 'lodash/isEqual';

var CookiesServiceClass = /** @class */ (function () {
    function CookiesServiceClass() {
    }
    Object.defineProperty(CookiesServiceClass, "instance", {
        get: function () {
            if (!this._instance)
                this._instance = new CookiesServiceClass();
            return this._instance;
        },
        enumerable: false,
        configurable: true
    });
    CookiesServiceClass.prototype.getAllCookies = function () {
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookies = decodedCookie
            .split(';')
            .map(function (item) { return item.trim(); })
            .reduce(function (acc, item) {
            var _a = item.split('='), key = _a[0], value = _a[1];
            acc[key] = value;
            return acc;
        }, {});
        return cookies;
    };
    CookiesServiceClass.prototype.getCookie = function (name) {
        var cookies = this.getAllCookies();
        return cookies[name];
    };
    CookiesServiceClass.prototype.getCookies = function (names) {
        var _this = this;
        var cookies = names.reduce(function (acc, item) {
            acc[item] = _this.getCookie(item);
            return acc;
        }, {});
        return cookies;
    };
    CookiesServiceClass.prototype.checkCookie = function (name, value) {
        var cookie = this.getCookie(name);
        return cookie === value;
    };
    CookiesServiceClass.prototype.checkCookies = function (expectedCookies) {
        var cookies = this.getCookies(Object.keys(expectedCookies));
        return isEqual(cookies, expectedCookies);
    };
    CookiesServiceClass.prototype.setCookie = function (name, value, expirationDays) {
        var d = new Date();
        d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/");
    };
    CookiesServiceClass.prototype.deleteCookie = function (name) {
        if (!this.cookieExists(name))
            return false;
        document.cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
        return true;
    };
    CookiesServiceClass.prototype.cookieExists = function (name) {
        var cookie = this.getCookie(name);
        return Boolean(cookie);
    };
    CookiesServiceClass.prototype.setOrUpdateCookie = function (name, value, expirationDays) {
        var updated = this.deleteCookie(name);
        this.setCookie(name, value, expirationDays);
        return updated;
    };
    return CookiesServiceClass;
}());
var CookiesService = CookiesServiceClass.instance;

export { CookiesService };
//# sourceMappingURL=index.js.map
